import React from 'react';

const PopUpPage = () => {
    return (
        <div className="d-flex flex-column align-items-center">
            <img src={"../assets/img/popup_img.jpg"} alt={"이미지 없음"} style={{
                width: '100%',
                maxWidth: '1200px',
                height: 'auto',
            }}/>
        </div>

    )
}

export default PopUpPage;
